import { safeJsonParse } from "@utils/safeJsonParse";

function decode(uri) {
	return decodeURIComponent(uri.replace(/\+/g, " "));
}

export const getProductId = async () => {
	if (typeof window === "undefined") return 1;

	const legacyPlanId = getLegacyPlanIdFromUrl();
	if (legacyPlanId) return Number(legacyPlanId);

	const branchPlanId = await getPlanIdFromBranch();
	if (branchPlanId) return Number(branchPlanId);

	const urlPlanId = getPlanIdFromUrl();
	if (urlPlanId) return Number(urlPlanId);

	return 1;
};

const getPlanIdFromBranch = async () => {
	// Wait for branch.init() to complete before calling branch.data().
	// The script uses strategy="beforeInteractive" but init() makes an async
	// network call — __branchInitialized is set in the init callback in _app.tsx.
	if (!window.__branchInitialized) {
		if (window.__branchFailed) return null;

		const BRANCH_INIT_TIMEOUT_MS = 10000;
		await Promise.race([
			new Promise((resolve) => {
				document.addEventListener("branch_initialized", () => resolve(), {
					once: true,
				});
			}),
			new Promise((resolve) => {
				document.addEventListener("branch_failed", () => resolve(), {
					once: true,
				});
			}),
			new Promise((resolve) => setTimeout(resolve, BRANCH_INIT_TIMEOUT_MS)),
		]);
	}

	if (!window?.branch) return null;

	return new Promise((resolve) => {
		window.branch.data((err, data) => {
			if (err) return resolve(null);

			const screenName = data?.data_parsed?.felix_app_screen_name;
			if (screenName && screenName !== "BuyPlanSummaryPage") {
				return resolve(null);
			}

			const parsedCustomData = safeJsonParse(
				data?.data_parsed?.felix_app_custom_data || "{}",
				{},
				{
					component: "funnel",
					action: "parse_branch_custom_data",
					metadata: { source: "branch" },
				},
			);

			const planId = parsedCustomData.value?.planId || null;

			// Store the promo code from Branch data so BuyContext's
			// getPromoCodeFromUrl can include it when fetching the initial
			// plan summary, avoiding a race with the separate promo application.
			const branchCode = parsedCustomData.value?.code || null;
			if (branchCode && typeof branchCode === "string") {
				window.__branchPromoCode = branchCode.trim();
			}

			resolve(planId);
		});
	});
};

const getPlanIdFromUrl = () => {
	try {
		const queryString = decode(window.location.search);
		const params = new URLSearchParams(queryString);
		const customData = params.get("felix_app_custom_data");
		if (!customData) return null;

		return (
			safeJsonParse(
				customData,
				{},
				{
					component: "funnel",
					action: "parse_querystring_custom_data",
					metadata: { source: "querystring" },
				},
			).value?.planId || null
		);
	} catch (err) {
		console.warn("Failed to fetch planId from URL data", err);
		return null;
	}
};

const getLegacyPlanIdFromUrl = () => {
	const match = window.location.href.match(/id=(.*)endid/);
	const code = match?.[1];
	if (!code || !["1", "2", "10", "11"].includes(code)) return null;
	return code;
};
